<template>
  <div id="app">
    <router-view :lang="lang" v-slot="{component}">
      <component :lang="lang" @changeLang="changeLang" />
    </router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {
      lang: 'EN'
    }
  },
  methods: {
    changeLang (lang) {
      this.lang = lang
    },
    detectLang() {
      // DETECT LANG FROM BROWSER
      const lang = navigator.language || navigator.userLanguage;
      this.lang = lang.split('-')[0].toUpperCase();
      if (this.lang !== 'EN' && this.lang !== 'ES') {
        this.lang = 'EN'
      }
    }
  },
  beforeMount() {
    this.detectLang()
  },
  mounted () {
    console.log('Cargando login desde App...')
  }
}
</script>
<style>
html{
  font-size: 16px;
}
</style>
